/*
 * File: c:\Users\j.mazat\Desktop\mobybuy_front\src\Content\Favorite\Favorite.tsx
 * Project: c:\Users\j.mazat\Desktop\mobybuy_front
 * Created Date: Monday April 29th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday, 15th July 2024 04:28:55
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { Fragment, useEffect, useState } from "react";
import CarsDisplay from 'Content/Car/CarsDisplay/CarsDisplay';
import { SingleCarFormat } from 'Content/Car/CarElement/CarElement.type';
import { useLoaderData } from 'react-router-dom';
import style from 'Content/Favorite/Favorite.module.css';
import translator from 'MultiLanguage/TranslationWrapper';
import CarService from "Services/Cars/CarService";

function Favorite(_:any){
    const favCars = useLoaderData() as [];
    const [favorite, setFavorite] = useState<SingleCarFormat[]>([]);

    useEffect(() => {
        const respCartList: SingleCarFormat[] = [];
        if (favCars)
            favCars.map((car: any) => {
                const tmp = CarService.transformSingleCar(car.Car);
                if (tmp !== null)
                respCartList.push(tmp);
            });
        setFavorite(respCartList);
    }, []);
    return (
        <Fragment>
            {
                favorite.length > 0 ?
                <h1 className={`${style.titleCart}`}>{translator.decode("cart.carSelectedInCart")} ({favorite.length}) :</h1>
                :
                <h1 className={`${style.titleCart}`}>{translator.decode("cart.noCarInCart")}</h1>
            }
            <CarsDisplay carList={favorite} themeColor={''}/>
        </Fragment>
    );
};

export default Favorite;
